export default "__VITE_ASSET__DnqLpH8H__"